import { toast } from 'alm-react-components';
import { signOut } from 'aws-amplify/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apis } from '../services/alm';
import { getSllUser } from '../services/user';
import { StatusCode } from '../assets/constants/constants';
import { clearLocalStorage, removeChainlitPopup } from '../lib/utils';
import { useCallback, useContext, useState } from 'react';
import { AppContext } from '../context/AppProvider';

const useRouteChangeHandler = () => {
    const [isProcessing, setIsProcessing] = useState(false)
     const location = useLocation();
       const { state } = useContext(AppContext);
     
     const navigate = useNavigate()
     const { t } = useTranslation()
    const handleRedirection = useCallback(async () => {
            if ( isProcessing || state?.user === null || location.pathname==="/") return

            try {
                const res = await apis.checkAlmUser().catch(() => {
                    return;
                });

                const result = res?.data;
                const sllUserInfo: any = await getSllUser(result.attributes.email);
                const headlessUserDetail = sllUserInfo?.data;
                if (headlessUserDetail?.syncStatus === StatusCode.USER_SYNC_STATUS) {
                    toast({ description: t("Validations.emailChangeToaster"), variant: "error" });
                    setTimeout(() => {
                        signOut().then(() => {
                            removeChainlitPopup();
                            navigate('/', { replace: true })
                        })
                        clearLocalStorage()
                    }, 5000)
                }
            } catch (error) {
                console.log("error", error)
            } finally {
                setIsProcessing(false)
        };
    }, [navigate])

    return (
        {
            handleRedirection
        }
    )
}

export default useRouteChangeHandler